/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { NotificationsControllerGetMyNotificationsQueryResponse, NotificationsControllerGetMyNotificationsQueryParams, NotificationsControllerGetMyNotifications401, NotificationsControllerGetMyNotifications403 } from "../../models/notificationsController/NotificationsControllerGetMyNotifications";

function getNotificationsControllerGetMyNotificationsUrl() {
  const res = { method: 'GET', url: `/api/v1/notifications` as const }  
  return res
}

/**
 * @description Returns notifications grouped into today, yesterday, this week, and older. Excludes soft-deleted notifications.
 * @summary Get all notifications for current user grouped by day
 * {@link /api/v1/notifications}
 */
export async function notificationsControllerGetMyNotifications(params?: NotificationsControllerGetMyNotificationsQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<NotificationsControllerGetMyNotificationsQueryResponse, ResponseErrorConfig<NotificationsControllerGetMyNotifications401 | NotificationsControllerGetMyNotifications403>, unknown>({ method : "GET", url : getNotificationsControllerGetMyNotificationsUrl().url.toString(), params, ... requestConfig })  
  return res.data
}